export default __webpack_public_path__ + "1ecfcc6bdc0039352c43aff4ba3f4c4f.svg";